import { FC } from 'react'
import styles from './ArticleFooter.module.scss'
import { socials } from 'constants/constants'
import { handleScrollToTop } from 'utils/helpers'
import Icon from 'components/icon/Icon'

const ArticleFooter: FC = () => {
  return (
    <section className={styles.footer}>
      <div className={styles['social-plug']}>
        Volg Bolt ook op{' '}
        <a href={socials.facebook} target="_blank" rel="noopener noreferrer">
          Facebook
        </a>{' '}
        en{' '}
        <a href={socials.instagram} target="_blank" rel="noopener noreferrer">
          Instagram
        </a>
      </div>
      <button className={styles['scroll-to-top']} onClick={() => handleScrollToTop()}>
        <span className={styles['icon-container']}>
          <Icon name="arrow-up" color="currentColor" size={18} />
        </span>
        Naar top
      </button>
    </section>
  )
}

export default ArticleFooter
